(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function getVideo(card) {
    return card.querySelector('.promo-cards-carousel__video');
  }

  function playVideo(card) {
    if (reduceMotion.matches) return;
    var video = getVideo(card);
    if (!video) return;
    video.muted = true;
    video.playsInline = true;
    card.classList.remove('is-ended');
    card.classList.add('is-playing');
    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        card.classList.remove('is-playing');
      });
    }
  }

  function stopVideo(card) {
    var video = getVideo(card);
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {
      /* ignore seek errors before metadata */
    }
    card.classList.remove('is-playing');
    card.classList.remove('is-ended');
  }

  function bindCard(card) {
    if (card.dataset.pcVideoBound === 'true') return;
    if (!card.classList.contains('promo-cards-carousel__card--has-video')) return;
    card.dataset.pcVideoBound = 'true';

    var video = getVideo(card);
    if (!video) return;

    video.muted = true;
    video.loop = false;
    video.removeAttribute('loop');

    card.addEventListener('mouseenter', function () {
      playVideo(card);
    });
    card.addEventListener('mouseleave', function () {
      stopVideo(card);
    });
    card.addEventListener('focusin', function () {
      playVideo(card);
    });
    card.addEventListener('focusout', function (e) {
      if (!card.contains(e.relatedTarget)) {
        stopVideo(card);
      }
    });

    video.addEventListener('ended', function () {
      card.classList.remove('is-playing');
      card.classList.add('is-ended');
      /* Stay on last frame — no restart/loop while still hovered/focused */
    });
  }

  function initPromoCarousel(root) {
    if (typeof Swiper === 'undefined') return;
    if (root.dataset.pcInit === 'true') return;
    var el = root.querySelector('.promo-cards-carousel__swiper');
    if (!el) return;
    root.dataset.pcInit = 'true';

    var prev = root.querySelector('.promo-cards-carousel__arrow--prev');
    var next = root.querySelector('.promo-cards-carousel__arrow--next');
    var slides = el.querySelectorAll('.promo-cards-carousel__slide');

    root.querySelectorAll('.promo-cards-carousel__card--has-video').forEach(bindCard);

    if (slides.length <= 1) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      return;
    }

    var swiper = new Swiper(el, {
      slidesPerView: 1.5,
      spaceBetween: 12,
      speed: 450,
      watchOverflow: true,
      breakpoints: {
        768: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
      },
      navigation: {
        prevEl: prev,
        nextEl: next,
      },
    });

    root._promoCardsSwiper = swiper;
  }

  function boot() {
    document.querySelectorAll('[data-promo-cards-carousel]').forEach(initPromoCarousel);
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
